import { useState } from 'react'
import { useSignup } from '../../hooks/useSignup'

import './Zugang.css'

export default function Signup() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const { signup, error } = useSignup()
  
  const handleSubmit = (e) => {
    e.preventDefault()
    signup(email, password, displayName)
  }

  return (
    <div>
      <div className="container py-5">
        <div className="row py-5">
          <div className="col d-flex justify-content-center">
            <main className="form-signin w-100 m-auto">
            <form onSubmit={handleSubmit} className="signup-form">
              <p className="h3 mb-3 fw-normal">Please sign up</p>
              <div className="form-floating">
                <input 
                  required
                  className="form-control" 
                  id="floatingInput" 
                  placeholder="name@example.com"
                  type="email" 
                  onChange={(e) => setEmail(e.target.value)} 
                  value={email}
                />
                <label htmlFor="floatingInput">Email address</label>
              </div>
              <div className="form-floating my-3">
                <input 
                  required
                  className="form-control" 
                  id="floatingPassword" 
                  placeholder="Password"
                  type="password" 
                  onChange={(e) => setPassword(e.target.value)} 
                  value={password}
                />
                <label htmlFor="floatingPassword">Password</label>
              </div>
              <div className="form-floating my-3">
                <input 
                  required
                  className="form-control" 
                  id="floatingDisplayName" 
                  placeholder="Unique Person ID (uuID) "
                  type="text" 
                  onChange={(e) => setDisplayName(e.target.value)} 
                  value={displayName}
                />
                <label htmlFor="floatingDisplayName">Display Name</label>
              </div>
              <button className="btn btn-success">Sign up</button>
              {error && <div className="error">{error}</div>}
            </form>
            </main>
          </div>
        </div>
      </div>
    </div>
  )
}